export interface User {
  id: string;
  firstName: string | null;
  lastName: string | null;
  displayName: string | null;
  email: string | null;
  phone: string | null;
  roles: string[] | null;
}

export interface Course {
  id: string;
  disabled: boolean;
  price: number;
  name: string;
  color: string;
  code: string;
  previewImg: string;
  urlCode: string;
  learningOutcomes: string[];
  modules: string[];
  desc: {
    short: string;
    long: string;
  };
  rating: {
    value: number;
    count: number;
  };
  features: [
    {
      desc: string;
      icon: string;
      title: string;
    }
  ];
  creationTime: {
    seconds: number;
    nanoseconds: number;
  };
  updateTime: {
    seconds: number;
    nanoseconds: number;
  };
}

export interface CatalogItem {
  id: string;
  code: string;
  urlCode: string;
  name: string;
  color: string;
  img: string;
  price: number;
}

export interface ShoppingCart {
  id: string;
  items: ShoppingCartItem[];
  amount: number;
  creationTime: Date;
  updateTime?: Date;
}

export interface ShoppingCartItem {
  id: string;
  type: ShoppingCartItemType.Course;
  creationTime: Date;
  name: string;
  price: number;
  previewImg: string;
}

export enum ShoppingCartItemType {
  Course = "course",
  Program = "program"
}
